import { useJsApiLoader } from '@react-google-maps/api'
import type { Libraries } from '@react-google-maps/api'

const LIBRARIES: Libraries = ['maps', 'places', 'geocoding']

const useGoogleMaps = () =>
  useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    libraries: LIBRARIES,
  })

export default useGoogleMaps
